// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1aL45","header":"MessagesList_header__2648Q","chat":"MessagesList_chat__1yFVN"};